<template src="./template.html"></template>
<style lang="scss" src="./styles.scss" scoped></style>

<script>
  import { mapActions, mapState } from 'vuex'
  import CookieOverlay from '@/components/overlays/CookieOverlay'

  export default {
    name: 'AppFooter',
    components: {
      CookieOverlay,
    },
    data: () => ({
      offsetBottom: 0,
      scrollTimer: null,
      resizeTimer: null,
      show_cookie_layer: false,
    }),
    computed: {
      ...mapState('pages', [ 'legal_pages' ]),
      ...mapState('auth', ['settings']),
      isMeta() {
        return document.querySelector('body.page_login, body.page_reset_password, body.page_forgot_password')
      },
      chatFab() {
        return document.querySelector('.chat-fab')
      },
    },
    created() {
      window.addEventListener('resize', this.onResize)
    },
    mounted() {
      // get footer links from legal_pages API
      this.getLegalPages().then(_ => {
        this.onResize()
      })
    },
    destroyed() {
      window.removeEventListener('resize', this.onResize)
    },
    methods: {
      ...mapActions('pages', [ 'getLegalPages' ]),
      onResize() {
        const isMeta = this.isMeta
        if (isMeta) {
          clearTimeout(this.resizeTimer)
          this.resizeTimer = setTimeout(() => {
            isMeta.style.marginBottom = null
            const contentBottom = document.querySelector('main.v-main div.container').getBoundingClientRect().bottom
            const footerTop = this.$refs.appFooter.$el.getBoundingClientRect().top
            const footerHeight = this.$refs.appFooter.$el.clientHeight
            const margin = contentBottom >= footerTop + 15 ? footerHeight + 15 : 0
            isMeta.style.marginBottom = `${margin}px`
          }, 250)
        }
      },
    },
  }
</script>
